import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from '../views/Home';
import Codes from '../views/nfpa_codes';

class Routes extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/nfpa-codes" component={Codes} />
            </Switch>
        );
    }
}
export default Routes;
